import { CoreGraphNode } from "../../../core/graph/CoreGraphNode";
export class WindowController {
  constructor(_scene) {
    this._scene = _scene;
    this._onWindowResizeBound = this._onWindowResize.bind(this);
  }
  graphNode() {
    return this._coreGraphNode = this._coreGraphNode || this._createGraphNode();
  }
  _createGraphNode() {
    const coreGraphNode = new CoreGraphNode(this._scene, "SceneWindowController");
    window.addEventListener("resize", this._onWindowResizeBound);
    return coreGraphNode;
  }
  _onWindowResize() {
    this.graphNode().setSuccessorsDirty();
  }
  dispose() {
    window.removeEventListener("resize", this._onWindowResizeBound);
  }
}
